import { useEffect, useState } from 'react';
import { collection, DocumentData, FirestoreError, getFirestore, query, QueryConstraint, QueryDocumentSnapshot } from 'firebase/firestore';
import { onSnapshot } from "firebase/firestore";

export interface PropsUseOnSnapshot {
  path: string;
  queryConstraint: QueryConstraint[];
  wait?: boolean;
}

const db = getFirestore();

const useOnSnapshot = <T extends { id: string; }>({ path, queryConstraint, wait }: PropsUseOnSnapshot) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [docs, setDocs] = useState<QueryDocumentSnapshot<DocumentData, DocumentData>[]>([]);
  const [data, setData] = useState<T[]>([]);
  const [error, setError] = useState<FirestoreError>();

  useEffect(() => {
    if (wait) return;

    const uns = onSnapshot(query(collection(db, path), ...queryConstraint), (_snapshot) => {
      setDocs(_snapshot.docs);
      setData(_snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })) as T[]);
      setLoading(false);
    }, (error) => {
      console.error(error);
      setLoading(false);
      setError(error);
    });

    return () => {
      uns();
    };
  }, [path, queryConstraint, wait]);

  return { data, setData, docs, loading, error };
};

export default useOnSnapshot;